import { Injectable } from '@angular/core';
import { TechnologyInfo } from '../diagnostics.models';

@Injectable({
  providedIn: 'root',
})
export class TechnologyCheckService {
  public getTechnologyInfo(): TechnologyInfo {
    const webglInfo = this._checkWebGL();

    return {
      webgl: webglInfo.supported,
      webglRenderer: webglInfo.renderer,
      webgl2: this._checkWebGL2(),
      webWorkers: this._checkWebWorkers(),
      serviceWorker: this._checkServiceWorker(),
      indexedDB: this._checkIndexedDB(),
      webSockets: this._checkWebSockets(),
    };
  }

  private _checkWebGL(): { supported: boolean; renderer?: string } {
    try {
      const canvas = document.createElement('canvas');
      const gl =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

      if (!gl) {
        return { supported: false };
      }

      const webglContext = gl as WebGLRenderingContext;
      const debugInfo = webglContext.getExtension('WEBGL_debug_renderer_info');
      let renderer: string | undefined;

      if (debugInfo) {
        renderer = webglContext.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }

      return { supported: true, renderer };
    } catch {
      return { supported: false };
    }
  }

  private _checkWebGL2(): boolean {
    try {
      const canvas = document.createElement('canvas');
      return !!canvas.getContext('webgl2');
    } catch {
      return false;
    }
  }

  private _checkWebWorkers(): boolean {
    return typeof Worker !== 'undefined';
  }

  private _checkServiceWorker(): boolean {
    return 'serviceWorker' in navigator;
  }

  private _checkIndexedDB(): boolean {
    return typeof indexedDB !== 'undefined';
  }

  private _checkWebSockets(): boolean {
    return typeof WebSocket !== 'undefined';
  }
}
